<!--
This component is for creating an agreement
-->
<template>
  <div class="wrapper">
    <dashboardNav/>
    <!-- Page Content  -->
    <div id="content">
      <div class="container">
        <!-- Alerts -->
      </div>

      <!-- Page Content  -->
      <div class="main container">
        <loader :isLoading="isAgreementsRequestInProgress"/>
        <h2>Agreements</h2>
        <div class="line"></div>

        <AgreementForm
          :form="form"
          :isEdit="isEdit"
          :isForm="isForm"
          :error="error"
          :action="action"
          :submitForm="submitForm"
          :cancelEdit="cancelEdit"
          :errorMessage="errorMessage"
          :clearMessage="clearMessage"
          submitButtonName="Edit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import {
  FETCH_AGREEMENT,
  EDIT_AGREEMENT
} from '@/store/types/actions.type'

import Loader from '@/components/common/Loader'
import DashboardNav from '@/components/common/DashboardNav'
import AgreementForm from '@/components/agreements/AgreementForm'

import Sidebar from '@/containers/dashboard/Sidebar'

import { AuthService } from '@/api/AuthService'

const auth = new AuthService()

export default {
  components: {
    sidebar: Sidebar,
    dashboardNav: DashboardNav,
    Loader,
    AgreementForm
  },
  data() {
    return {
      userId: auth.getUserId(),
      form: {
        agreement_name: '',
        other_agreement_name: '',
        type: '',
        content: '',
        link: ''
      },
      error: {
        agreement_name: ''
      },
      editData: {},
      errorMessage: '',
      action: 'add',
      isForm: true,
      isEdit: true,
      haveError: false,
      haveVuelidateError: false,
      requestInProgress: false
    }
  },
  computed: {
    ...mapGetters([
      'getAgreementData',
      'isAgreementsRequestInProgress'
    ])
  },
  mounted() {
    this.agreementId = this.$route.params.id
    this.getBusinessAgreement()
  },
  methods: {
    clearMessage() {
      this.errorMessage = ''
    },
    getBusinessAgreement() {
      const self = this
      this.$store.dispatch(FETCH_AGREEMENT, this.agreementId)
      .then(d => { self.setupFormData(d) })
      .catch(e => { self.error_message = e })
    },
    setupFormData(data) {
      if(data.type === 'link') {
        this.form = {
          agreement_name: data.agreement_name,
          link: data.link,
          content: '',
          other_agreement_name: data.other_agreement_name,
          type: data.type
        }
      } else {
        this.form = {
          agreement_name: data.agreement_name,
          link: '',
          content: data.content,
          other_agreement_name: data.other_agreement_name,
          type: data.type
        }
      }

      if(data.agreement_name === 'Data Privacy Agreement') {
        this.form.agreement_name = 'Others'
        this.form.other_agreement_name = 'Data Privacy Agreement'
      }
    },
    updateAgreement() {
      const self = this
      const fields = this.form

      const id = self.agreementId
      this.$store.dispatch(EDIT_AGREEMENT, {id, fields})
      .then(data => {
        if (data.statusCode === 200) {
          self.redirectToPage()
        } else {
          self.errorMessage = data.message
        }
      })
      .catch(e => { self.errorMessage = e })
    },
    cancelEdit(){
      this.redirectToPage()
    },
    submitForm() {
      this.updateAgreement()
    },
    redirectToPage() {
      this.$router.push('/dashboard/agreements')
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/agreements/EditAgreement.vue